import { Injectable, Renderer2 } from '@angular/core';
import { Observable, Subject, of, tap } from 'rxjs';
import { DataSourceMeta, DocAnnotation, TextItem } from '../models';
import { Loader } from './loader';

@Injectable()
export class WindowLoaderService extends Loader {
    private _messages = new Subject<
        MessageEvent<{ type: string; data: any; name: string; selectedStampId?: string }>
    >();
    private _selectedStampId: string = null;

    public constructor(private renderer2: Renderer2) {
        super();
        this.renderer2.listen(window, 'message', (ev) => {
            if (ev.source === window.opener && ev.data?.name === window.name) {
                this._messages.next(ev);
            }
        });
    }

    public GetPdf(): Observable<File> {
        return new Observable<File>((s) => {
            this._messages
                .pipe(
                    tap((ev) => {
                        switch (ev.data?.type) {
                            case 'pdfcontent':
                                {
                                    if (ev.data.selectedStampId) {
                                        this._selectedStampId = ev.data.selectedStampId;
                                    }
                                    s.next(ev.data.data as File);
                                    s.complete();
                                }
                                break;
                        }
                    }),
                )
                .subscribe();
            window.opener.postMessage(
                { type: 'pdfready', name: window.name },
                { targetOrigin: '*' },
            );
        });
    }

    public GetSelectedStampId(): string {
        return this._selectedStampId;
    }

    public GetPdfDataSource(): Observable<DataSourceMeta[]> {
        return of(null);
    }

    public SavePdf(pdf: File): Observable<void> {
        return new Observable((s) => {
            window.opener.postMessage(
                { type: 'savepdf', data: pdf, name: window.name },
                { targetOrigin: '*' },
            );
            s.next();
            s.complete();
        });
    }

    public GetTextItems(): Observable<TextItem[]> {
        return new Observable<TextItem[]>((s) => {
            this._messages
                .pipe(
                    tap((ev) => {
                        switch (ev.data?.type) {
                            case 'textItems':
                                {
                                    s.next(ev.data.data);
                                    s.complete();
                                }
                                break;
                        }
                    }),
                )
                .subscribe();
            window.opener.postMessage(
                { type: 'requestTextItems', name: window.name },
                { targetOrigin: '*' },
            );
        });
    }

    public GetAnnotations(): Observable<DocAnnotation[]> {
        return new Observable<DocAnnotation[]>((s) => {
            this._messages
                .pipe(
                    tap((ev) => {
                        switch (ev.data?.type) {
                            case 'annotations':
                                {
                                    for (const ann of ev.data.data as any[]) {
                                        if (
                                            ann.annotFile &&
                                            ann.annotFile instanceof ArrayBuffer
                                        ) {
                                            ann.annotFile = new Blob([ann.annotFile], {
                                                type: 'application/octet-stream',
                                            });
                                    }

                                    s.next(ev.data.data);
                                    s.complete();
                                }
                                break;
                        }
                    }})
                )
                .subscribe();

            window.opener.postMessage(
                { type: 'requestAnnotations', name: window.name },
                { targetOrigin: '*' }
            );
        });
    }

    public Dispose() {
        window.opener.postMessage(
            { type: 'dispose', name: window.name },
            { targetOrigin: '*' },
        );
    }
}
